"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformProfitLossReportResponse = exports.transformProfitLossReportData = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Error_1 = require("../Error");
const ProfitLossEntry_1 = require("./ProfitLossEntry");
function transformProfitLossReportData({ cash_based, company_name, currency_code, labels, download_token, end_date, expenses, gross_margin, income, net_profit, resolution, start_date, total_expenses, total_income, }) {
    return {
        companyName: company_name,
        currencyCode: currency_code,
        cashBased: cash_based,
        startDate: start_date,
        endDate: end_date,
        resolution: resolution,
        labels: labels,
        downloadToken: download_token,
        expenses: expenses && (0, ProfitLossEntry_1.transformProfitLossEntryResponseList)(expenses),
        grossMargin: gross_margin && (0, ProfitLossEntry_1.transformProfitLossEntryResponse)(gross_margin),
        income: income && (0, ProfitLossEntry_1.transformProfitLossEntryResponseList)(income),
        netProfit: net_profit && (0, ProfitLossEntry_1.transformProfitLossEntryResponse)(net_profit),
        totalExpenses: total_expenses && (0, ProfitLossEntry_1.transformProfitLossEntryResponse)(total_expenses),
        totalIncome: total_income && (0, ProfitLossEntry_1.transformProfitLossEntryResponse)(total_income),
    };
}
exports.transformProfitLossReportData = transformProfitLossReportData;
/**
 * Parses JSON ProfitLossReport response and converts to @ProfitLossReport model
 * @param data representing JSON response
 * @returns @ProfitLossReport | @Error
 */
function transformProfitLossReportResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { response: { result }, } = response;
    const { profitloss } = result;
    return transformProfitLossReportData(profitloss);
}
exports.transformProfitLossReportResponse = transformProfitLossReportResponse;
//# sourceMappingURL=ProfitLossReport.js.map